import { Clock, MapPin, Car, ShieldCheck } from "lucide-react";
import { EVENT } from "../config";
import { useReveal } from "../hooks/useReveal";

const INFO_ITEMS = [
  { Icon: Clock, title: "Timing", text: `Doors ${EVENT.doorsOpen} · Show Starts ${EVENT.showStart}` },
  { Icon: MapPin, title: "Location", text: "Premium venue in North Raleigh" },
  { Icon: Car, title: "Parking", text: "Complimentary parking available at venue" },
  { Icon: ShieldCheck, title: "Age Limit", text: "Strictly 18+ with Valid ID" },
];

export default function Venue() {
  const headRef = useReveal();
  const gridRef = useReveal();

  return (
    <section id="venue" className="py-32 relative">
      <div className="container mx-auto px-6">
        <div ref={headRef} className="reveal mb-20 text-center">
          <h2 className="text-5xl md:text-7xl font-serif text-white">{EVENT.venue}</h2>
          <p className="text-gray-500 text-lg mt-4">{EVENT.address}</p>
        </div>

        <div ref={gridRef} className="reveal grid grid-cols-1 md:grid-cols-2 gap-10 max-w-6xl mx-auto items-stretch">
          {/* Map */}
          <div className="rounded-[2.5rem] overflow-hidden border border-white/10 h-[450px] shadow-2xl relative">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.0!2d-78.6375!3d35.818!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89ac5f6d845c3e5d%3A0x0!2s600+Creekside+Dr%2C+Raleigh%2C+NC+27609!5e0!3m2!1sen!2sus!4v1"
              className="w-full h-full border-0"
              style={{ filter: "grayscale(1) invert(0.9) contrast(1.2)" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Enigma Nightclub, 600 Creekside Dr, Raleigh NC"
            />
            <div className="absolute inset-0 pointer-events-none ring-1 ring-inset ring-white/10" />
          </div>

          {/* Info */}
          <div className="bg-[#111] border border-white/10 p-10 md:p-12 rounded-[2.5rem] flex flex-col justify-center gap-8 shadow-xl">
            {INFO_ITEMS.map(({ Icon, title, text }) => (
              <div key={title} className="flex items-start gap-6">
                <div className="w-12 h-12 bg-[#C9ED00]/10 rounded-2xl flex items-center justify-center shrink-0">
                  <Icon className="w-6 h-6 text-[#C9ED00]" />
                </div>
                <div>
                  <h4 className="text-white font-semibold mb-1">{title}</h4>
                  <p className="text-gray-400">{text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
